import {EnumToMapping, SelectOption} from "common";
import {tryFormatLocalDate} from "common/util/date";
import {AuthorizationInfo, ClientProfile, ClientReportInfo, SortOrder} from "../client/domain";
import {splitAndRemoveEmpty} from "../../placement/const";
import {Person} from "../../core/domain";
import {CurrentUserData} from "../../security";

export interface ProviderEventColumn {
    name: string;
    attr: string;
}

export type ProviderEventListFilterValue = {
    clients: SelectOption[],
    eventSince: Date | null;
    eventTypes: string;
    viewedOnly: string;
    reportSubmittedBy: SelectOption[];
}

export interface ProviderEventSortBy {
    column: string
    order: SortOrder;
}

export type ProviderEvent = {
    guid: string;
    eventType: string;
    eventTime: string;
    viewedAt: string;
    client: ClientProfile;
    authorization: AuthorizationInfo;
    clientDocumentType: string;
    authChangedSections: string;
    viewedBy: Person;
    clientReport: ClientReportInfo;
    caseSfId: string;
    caseNumber: string;
    holdEndDate: string;
    holdReminderNumber: number;
    holdActionCompletedAt: string;
    linkedClients?: ClientProfile[];
    // --- PLACEHOLDER ONLY
    _description: string;
    _actions: string;
}

export enum ProviderEventType {
    Placement_Confirmed = "Placement Confirmed",
    Authorization_Assigned = "Authorization Assigned",
    Authorization_Updated = "Authorization Updated",
    Authorization_Report_Due = "Report Past Due",
    Client_Report_Feedback = "Client Report Feedback",
    Client_Report_Approved = "Client Report Authorized",
    Client_Document_Added = "Client Document Added",
    Treatment_Hold_End = "Treatment Hold End",
    Staffing_Plan_Required = "Staffing Plan Required",
    Progress_Portrait_Sync = "Progress Portrait(s) Available",
}

export const {
    names: ProviderEventTypeNames,
    nameToValue: ProviderEventTypeNameMap,
    valueToName: ProviderEventTypeValueToName,
} = EnumToMapping(ProviderEventType, {value: "", label: "All Type"})

export enum ProviderEventViewOnlyOption {
    Unread = "Unread",
    Read = "Read",
}

export const canUserMarkUnreadOrRead = (user: CurrentUserData | null, providerEvent: ProviderEvent) => {
    const eventType = ProviderEventTypeNameMap.get(providerEvent.eventType);
    if (eventType === ProviderEventType.Client_Report_Feedback
        || eventType === ProviderEventType.Client_Report_Approved
    ) {
        return user?.guid === providerEvent.clientReport.submittedBy.guid;
    }
    return true;
}

export const {
    nameToValueWithDefault: ProviderViewOnlyOptionMapWithDefault,
} = EnumToMapping(ProviderEventViewOnlyOption, {value: "", label: "All Status"})

export const asQueryParam = (filterValue: ProviderEventListFilterValue) => {
    let viewedOnlySelected = filterValue.viewedOnly != null ? filterValue.viewedOnly : null;
    return {
        eventSince: tryFormatLocalDate(filterValue?.eventSince ?? null),
        eventTypes: splitAndRemoveEmpty(filterValue?.eventTypes),
        viewedOnly: viewedOnlySelected ? viewedOnlySelected === ProviderEventViewOnlyOption.Read : null,
        clientGuids: filterValue?.clients.map((opt) => opt.value),
        submitterByGuids: filterValue?.reportSubmittedBy.map((opt) => opt.value)
    };
}

